import VueGtag from 'vue-gtag';

// Not to be included in the plugins index, installed at the module level
export default {
  install(Vue, options) {
    Vue.use(VueGtag, options);
  },
};
